import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import CMTFront from "../../assets/img/new/note.png";

import Spinner from "../../assets/img/loading.gif";
import { useHistory } from "react-router";

const appUrl = `${process.env.REACT_APP_API_URL}`;

function PageUploadOrganization(props) {
  const history = useHistory();

  const _maxFileSize = 8;
  const [isLoading, setIsLoading] = useState(false);

  const refFileFront = useRef(null);

  const { organizationResult, _handleToast, dataAccount } = props;

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
  }, []);

  function _handleClickFront() {
    if (refFileFront.current) refFileFront.current.click();
  }

  function readFile(e) {
    const { name, files } = e.target;

    if (files && files[0]) {
      var filesize = (files[0].size / 1024 / 1024).toFixed(4);
      if (filesize > _maxFileSize) {
        _handleToast(
          "Quý khách vui lòng upload file không quá " + _maxFileSize + "MB",
          "warning"
        );
        if (name === "front_mask") {
          document.getElementById("image-preview-front").nodeValue = "";
        }
        return;
      }

      let _node;

      if (name === "front_mask") {
        _node = document.getElementById("image-preview-front");
      }

      var reader = new FileReader();

      reader.onload = function (e) {
        // preview
        _node.setAttribute("src", e.target.result);
      };

      reader.readAsDataURL(files[0]); // convert to base64 string
    }
  }

  function validateStep2() {
    let isCheck = true;
    var file1 = document.getElementById("ekyc-field-front-mask");

    if (!file1.files || !file1.files[0]) {
      isCheck = false;
    }

    return isCheck;
  }

  function _handleUploadFile() {
    if (!validateStep2()) {
      _handleToast("Quý khách hãy chọn file upload", "warning");
      return;
    }
    setIsLoading(true);
    var file1 = document.getElementById("ekyc-field-front-mask");

    const formData = new FormData();
    formData.append("anhMatTruoc", file1.files[0]);

    // upload file
    const request = fetch(appUrl + "/uploadFile", {
      method: "POST",
      body: formData,
    });
    request
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          const { data } = json;
          handleRequestOcr(data);
        } else {
          setIsLoading(false);
          _handleToast(json.rs, "error");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        _handleToast(
          "Có lỗi trong quá trình xử lý. Vui lòng thử lại!",
          "error"
        );
        throw error;
      });
  }

  function handleRequestOcr(params) {
    const _params = {
      linkFile: params?.anhMatTruoc,
    };

    organizationResult(_params);

    return;

    const param = {
      anhMatTruoc: params?.anhMatTruoc,
      anhMatSau: params?.anhMatSau,
    };

    const url = `${appUrl}/ocrFpt`;
    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then((response) => response.json())
      .then((json) => {
        setIsLoading(false);

        if (json.iRs === 1) {
          // create request

          if (json.data.message) {
            _handleToast(json.data.message, "error");
          } else {
            const { data } = json;
            const _params = {
              name: data?.hoVaTen || "",
              cardId: data?.soCmt || "",
              address: data?.noiTru || "",
              birthday: data?.namSinh || "",
              sex: data?.gioiTinh || "",
              expiry: data?.ngayHetHan || "",
              issue_date: data?.ngayCap || "",
              issue_by:
                data?.loaiCmt === "cccd_chip_ms"
                  ? "Cục CS QLHC về TTXH"
                  : data?.noiCap || "",
              province: data?.chiTietNoiTru?.province || "",
              anhMatTruoc: params?.anhMatTruoc,
              anhMatSau: params?.anhMatSau,
            };

            organizationResult(_params);
          }
        } else {
          _handleToast(json.rs, "error");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        _handleToast(
          "Có lỗi trong quá trình xử lý. Vui lòng thử lại!",
          "error"
        );
        throw error;
      });
  }

  return (
    <>
      {isLoading && (
        <div className="loading">
          <img src={Spinner} alt="" />
        </div>
      )}
      <Container>
        <Row>
          <Col lg="10" className="offset-lg-1">
            <div className="content pt180">
              <h2>Tải ảnh GCN ĐKDN</h2>
              <form
                className="yt-online-form-step mt-0 mb-5"
                id="OnlineForm-step-2"
                method="post"
                encType="multipart/form-data"
                noValidate="novalidate"
              >
                <div className="yt-alert-message alert alert-info" role="alert">
                  <span className="text-danger">*</span> ảnh chụp GCN Đăng ký
                  doanh nghiệp còn hiệu lực, không bị mờ, bóng. Thông tin hiển
                  thị đầy đủ và rõ ràng. Các định dạng file được chấp nhận:{" "}
                  <span className="highlight-info">jpg, jpeg,png</span>. Kích
                  thước tệp tối đa: <span className="highlight-info">8MB</span>.
                </div>
                <div className="yt-identify-card-wrap">
                  <Row className="mt-3">
                    <Col className="front-wrap text-center">
                      <div className="identify-card-item">
                        <h6 className="title">
                          TẢI ẢNH GCN ĐĂNG KÝ DOANH NGHIỆP
                        </h6>
                        <div className="yt-upload-wrap" data-type="front">
                          <div
                            className="bg"
                            style={{ width: "100px", margin: "20px 20px 30px" }}
                          >
                            <img
                              src={CMTFront}
                              alt=""
                              onClick={_handleClickFront}
                            />
                            {/* <CMTFront onClick={_handleClickFront} /> */}
                          </div>
                          <div className="image-preview-wrap">
                            <img
                              id="image-preview-front"
                              className="image-popup-no-margins image-preview"
                              src=""
                              href=""
                              alt="Ảnh CMND/CCCD mặt trước"
                              title="Ảnh CMND/CCCD mặt trước"
                              onClick={_handleClickFront}
                            />
                          </div>

                          <input
                            ref={refFileFront}
                            name="front_mask"
                            id="ekyc-field-front-mask"
                            type="file"
                            accept="image/*"
                            className="valid"
                            aria-invalid="false"
                            onChange={(event) => {
                              readFile(event);
                            }}
                          />
                        </div>
                      </div>
                      <div className="actions">
                        <a
                          type="buton"
                          className="btn yt-btn style-2 upload-image-button"
                          onClick={_handleClickFront}
                        >
                          Tải lên
                        </a>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mt-4 mb-5">
                    <Button
                      onClick={() => history.goBack()}
                      className="prev-page"
                    >
                      Quay lại
                    </Button>
                    <Button
                      className="btn-next"
                      type="button"
                      onClick={_handleUploadFile}
                    >
                      TIẾP TỤC
                    </Button>
                  </Row>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PageUploadOrganization;
